export default __webpack_public_path__ + "static/43-028213177cfb77443cc3520819eea4b0.png";